<template>
  <RevCard class="mb-16 p-16">
    <div class="flex flex-wrap items-center justify-between">
      <div>
        <div class="heading-1 mb-20">
          {{ i18n(translations.feedbackBlockTitle) }}
        </div>
        <div class="body-1 mb-20">
          {{ i18n(translations.feedbackBlockDescription) }}
        </div>
        <RevButton
          :to="{
            name: ROUTE_NAMES.ONBOARDING.FEEDBACK,
            query: { formId: 'phNJ3q16' },
          }"
          variant="primary"
        >
          {{ i18n(translations.feedbackBlockButtonLabel) }}
        </RevButton>
      </div>
      <RevIllustration
        :alt="i18n(translations.feedbackImageAlt)"
        :height="240"
        src="/img/merchants/question_mark.svg"
        :width="240"
      />
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './OnboardingFeedback.translations'

const i18n = useI18n()
</script>
